/**
 * Fixes a confirmed live bug: leaving a Shows booking-funnel page via a vendor-rendered plain
 * `<a href>` link (a REAL cross-document browser navigation, not a Next client-side transition)
 * and then pressing Back can restore a STALE, PARTIALLY loaded copy of that exact page —
 * confirmed via a live Playwright repro on the Show Detail Page: the browser reuses a cached HTTP
 * response for the page's own document request, `event.persisted` is `false` on that `pageshow`
 * (this is NOT the browser's in-memory bfcache) but
 * `performance.getEntriesByType('navigation')[0].type` IS `'back_forward'`.
 *
 * Every client component that depends on its own `useEffect` to finish loading is left stuck on
 * its initial placeholder forever — confirmed live that REACT NEVER HYDRATES this stale snapshot
 * at all (a `console.log` at the top of a mounted client component's effect never fires), so a
 * React-based fix (e.g. a `useEffect` + `router.refresh()`) can never run — it depends on the
 * exact hydration that never happens. This has to be a plain script that registers its `pageshow`
 * listener during the initial HTML parse, before React/hydration are even in the picture — same
 * reasoning as the reference CMS's own top-of-file `$(window).on("pageshow", …)` in
 * `seatplan.js`/`theater-checkout.js`, which this mirrors (checking the same
 * `persisted || navigation.type === 'back_forward'` condition) with a hard `location.reload()`
 * instead of `router.refresh()`, since only a real fresh network fetch is guaranteed to bypass
 * whatever cached the stale copy in the first place. Self-terminating: the reload's own
 * `pageshow` reports `type: 'reload'`, not `'back_forward'`, so this never loops.
 *
 * Shared by every Shows page reachable via a vendor-rendered full-page navigation — the Show
 * Detail Page (vendor "Select" link → Seat Selection), the Seat Selection Page ("Reserve
 * Tickets" → Checkout is a Next `<Link>`/`router.push`, but the vendor Calendar's own links can
 * still land back here), and Checkout (reached from Seat Selection's real full-page LTD
 * redirect chain) — see each page's own `<script dangerouslySetInnerHTML>` usage.
 */
export const BACK_FORWARD_RELOAD_SCRIPT = `(function () {
  function onPageShow(e) {
    var nav = performance.getEntriesByType('navigation')[0];
    if (e.persisted || (nav && nav.type === 'back_forward')) {
      location.reload();
    }
  }
  window.addEventListener('pageshow', onPageShow);
})();`;
